import { useMemo } from 'react'

import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import { createTheme } from '@mui/material'

import ComponentOverrides from './overrides'
import Typography from './typography'
import Palette from './palette'
import CustomShadows from './shadows'

export default function ThemeCustomization({ children }) {
    const theme = Palette()

    const themeTypography = Typography("'Roboto', sans-serif")

    const themeCustomShadows = useMemo(() => CustomShadows(theme), [theme])

    const themeOptions = useMemo(
        () => ({
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 429,
                    md: 768,
                    lg: 1024,
                    xl: 1200,
                },
            },
            palette: theme.palette,
            direction: 'ltr',
            spacing: 1,
            customShadows: themeCustomShadows,
            typography: themeTypography,
        }),
        [theme, themeTypography, themeCustomShadows],
    )

    const themes = createTheme(themeOptions)
    themes.components = ComponentOverrides(themes)

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes}>
                <CssBaseline />

                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    )
}
